import { IconButton } from "@mui/material"
import AddTaskIcon from "@mui/icons-material/AddTask"
import RemoveDoneIcon from "@mui/icons-material/RemoveDone"

import {
	CModalHeader,
	CModalBody,
	CModalFooter,
	CModal,
	CModalTitle,
	CButton,
	CTooltip,
} from "@coreui/react"
import "@coreui/coreui/dist/css/coreui.min.css"

import React from "react"
import EntrenoEntry from "../EntrenosComponent/EntrenoEntry"

class PopUpComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			trainingDone: false,
			visible: false,
		}
	}

	componentDidMount() {
		this.setState({ visible: this.props.visible })
	}
	render() {
		const work_date = new Date(
			this.props.data.DATE.seconds * 1000 +
				this.props.data.DATE.nanoseconds / 1000000
		)
		return (
			<>
				<CModal
					alignment="center"
					scrollable
					visible={this.state.visible}
					onClose={() => this.setState({ visible: false })}
				>
					<CModalHeader>
						<CModalTitle>
							Día: {work_date.toLocaleDateString("es-ES")}
						</CModalTitle>
					</CModalHeader>
					<CModalBody>
						<EntrenoEntry data={this.props.data} />
					</CModalBody>
					<CModalFooter>
						<CButton
							color="secondary"
							onClick={() => this.setState({ visible: false })}
						>
							Close
						</CButton>
						{!this.state.trainingDone ? (
							<IconButton variant="contained" disabled>
								<CTooltip content="Marcar completado">
									<AddTaskIcon />
								</CTooltip>
							</IconButton>
						) : (
							<IconButton variant="contained">
								<CTooltip content="Marcar NO completado">
									<RemoveDoneIcon />
								</CTooltip>
							</IconButton>
						)}
					</CModalFooter>
				</CModal>
			</>
		)
	}
}

export default PopUpComponent
